const Badge = ({ children, className = "" }) => (
  <p
    className={`badge-shimmer mb-5 inline-flex items-center rounded-full border border-white/15 bg-white/10 px-4 py-2 text-xs font-semibold uppercase tracking-[0.22em] text-[var(--website-secondary-color)] backdrop-blur-sm sm:text-sm ${className}`}
  >
    {children}
  </p>
);

export default Badge;
